export const GrossProfitQuery = {
  GET_CBX_TYPE: ``,
  GET_CBX_GOLD_AGE: ``,
  GET_GROSS_PROFIT: `query GetCompoundInterest($input: TcompoundInterestWhereInput!, $skip: Float!, $take: Float!){
    getCompoundInterest(where: $input, skip: $skip, take: $take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            age
            compoundInterest
            moneyId
            money{
                id
                name
            }
            mrp
            percentProfit
            plantId
            processPrice
            type
            tcreateUser{
                id
                fullName
            }
            createDate
            tmodifyUser{
                id
                fullName
            }
            modifyDate
        }
    }
}`,
  SAVE_GROSS_PROFIT: `mutation CreateCompoundInterest($input: TcompoundInterestInput!){
    createCompoundInterest(input: $input){
        id
        age
        compoundInterest
        moneyId
        mrp
        percentProfit
        plantId
        processPrice
        type
    }
}`,
  // Get Age ComboBox
  GET_AGE_COMBOBOX: `query GetListAgeComboBox($input:TproductWhereInput!, $skip: Float, $take: Float){
    getProduct(where:$input,groupBy:[age], skip: $skip, take: $take, orderBy: {age: ASC})
    {
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            age
        }
    }
}`,
  // Update Compound Interest
  UPDATE_COMPOUND_INTEREST: `mutation UpdateCompoundInterest($input: TcompoundInterestInput!){
   updateCompoundInterest(input: $input){
        id
        plantId
        type
        age
        mrp
        percentProfit
    }
}`,
};
